import { connect } from 'react-redux';
import { TripType } from '@eti/schema-types';
// oxlint-disable-next-line no-restricted-imports -- TODO WEBTECH-1501: Replace old schema object types with operation-specific types.

import { change } from 'redux-form';
import { breakpoints } from '@etg/wings';
import { css } from '@eti/styles';
import { AirportAvailability } from '@eti/components';
import { availabilityReadMoreGrid } from '../../common/utils/styles';
import { ProductCardLayoutType } from '../../common/models/product';
import { getSelected } from '../../single-choice/utils/selection';
import { FAST_TRACK } from '../../products';
import { getUpsellProps } from '../../common/utils/productCardProps';
import ProductLayout from '../../common/main-layout/ProductLayout';
import { useProductData } from '../../common/hook/useProductData';
import SmallCardLayout from '../../common/components/small-card-layout/SmallCardLayout';
import { getAvailabilityList, getCartAvailability } from '../../common/utils/availability';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const {
  name: PRODUCT_NAME,
  id: PRODUCT_ID
} = FAST_TRACK;
const {
  Small: SMALL_CARD_LAYOUT,
  Main: MAIN_CARD_LAYOUT,
  PostBooking: POSTBOOKING_CARD_LAYOUT
} = ProductCardLayoutType;
const sharedTexts = {
  readMoreContent: 'fastTrackReadMoreModalContent',
  title: 'fastTrackTitle',
  availabilityTitle: 'fasttrackAvailabilityCardAvailabilityTitle',
  departingTitle: 'fasttrackAvailabilityCardDeparting',
  returnTitle: 'fasttrackAvailabilityCardReturn',
  availableStatus: 'fasttrackAvailabilityCardAvailableStatus',
  unavailableStatus: 'fasttrackAvailabilityCardUnavailableStatus',
  addedStatus: 'fasttrackAvailabilityCardAddedStatus',
  addedTitle: 'fasttrackAvailabilityCardAddedTitle',
  statusTooltip: 'fasttrackAvailabilityCardStatusTooltip',
  fasttrackCartPurchasedMessage: 'fasttrackCartPurchasedMessage'
};
const largeLayoutTranslations = {
  ...sharedTexts,
  abstractContent: 'fastTrackAbstract',
  upSell: 'fastTrackUpSellText'
};
const translations = {
  [MAIN_CARD_LAYOUT]: largeLayoutTranslations,
  [POSTBOOKING_CARD_LAYOUT]: largeLayoutTranslations,
  [SMALL_CARD_LAYOUT]: {
    ...sharedTexts,
    abstractContent: 'fastTrackAbstractSmallCard',
    upSell: 'fastTrackUpSellTextSmallCard'
  }
};
const productCardGrid = isSmallCardLayout => css`
  grid-area: 5 / ${isSmallCardLayout ? 1 : 2} / 6 / 3;
  ${isSmallCardLayout && 'margin-top: 8px;'}

  @media (min-width: ${breakpoints._768}) {
    margin-inline-start: ${isSmallCardLayout ? '0' : '16px'};
    ${isSmallCardLayout ? css`
          margin-top: 16px;
          max-width: 522px;
        ` : 'width: auto;'}
  }
`;
const availabilityWidgetWrapper = css`
  display: grid;
  grid-area: 5 / 2 / 6 / 3;
  justify-items: end;
`;
const FastTrack = ({
  className,
  form,
  isSelected,
  order,
  productSpecificTexts,
  productCode,
  productPosition,
  dispatch,
  tripType,
  layoutType = MAIN_CARD_LAYOUT
}) => {
  const texts = translations[layoutType] || {};
  const isMultiStop = tripType !== TripType.OneWay && tripType !== TripType.Return;
  const {
    rootElement,
    productData,
    translation,
    isSmallCardLayout
  } = useProductData({
    className,
    form,
    isSelected,
    layoutType,
    order,
    productId: PRODUCT_ID,
    productName: PRODUCT_NAME,
    productCode,
    productPosition,
    texts
  });
  if (!productData) {
    return null;
  }
  const productSegmentAvailabilityTexts = productSpecificTexts && 'productSegmentAvailabilityTexts' in productSpecificTexts ? productSpecificTexts.productSegmentAvailabilityTexts : null;
  const availabilityList = getAvailabilityList(order.bounds, productSegmentAvailabilityTexts);
  const shouldDisplayAvailability = availabilityList.length > 0;
  const {
    availabilityTitle,
    departingTitle,
    fasttrackCartPurchasedMessage,
    returnTitle,
    addedTitle,
    addedStatus,
    availableStatus,
    statusTooltip,
    unavailableStatus,
    upSell
  } = translation;
  const {
    upSellObject,
    isUpsellHighlight = false,
    shouldDisplayUpsell = false
  } = getUpsellProps(upSell, {
    shouldDisplayAvailability,
    availabilityList,
    tripType
  });
  const handleAvailabilitySelection = value => {
    if (!dispatch) {
      return;
    }
    if (value === 'true' && shouldDisplayAvailability) {
      var _order$travelers$leng, _order$travelers;
      dispatch(change(form, `${PRODUCT_NAME}.cartBreakDown`, getCartAvailability((_order$travelers$leng = (_order$travelers = order.travelers) === null || _order$travelers === void 0 ? void 0 : _order$travelers.length) !== null && _order$travelers$leng !== void 0 ? _order$travelers$leng : 0, fasttrackCartPurchasedMessage, availabilityList)));
    }
  };
  const updatedExtraProps = {
    ...productData.extraProps,
    availabilityTitle,
    addedStatus,
    addedTitle,
    availabilityList,
    availableStatus,
    departingTitle,
    onButtonChange: handleAvailabilitySelection,
    returnTitle,
    statusTooltip,
    unavailableStatus
  };
  const updatedProductData = {
    ...productData,
    extraProps: updatedExtraProps,
    upSell: upSellObject,
    isHighlighted: isUpsellHighlight,
    shouldDisplayUpsell
  };
  const availabilityWidget = isSelected && shouldDisplayAvailability && /*#__PURE__*/_jsx(AirportAvailability, {
    className: productCardGrid(isSmallCardLayout),
    isMultiStop: isMultiStop,
    isSelected: isSelected,
    productData: updatedProductData,
    testid: "availability-purchase"
  });
  if (layoutType === SMALL_CARD_LAYOUT) {
    return /*#__PURE__*/_jsxs(SmallCardLayout, {
      productData: updatedProductData,
      ref: rootElement,
      children: [shouldDisplayAvailability && /*#__PURE__*/_jsx(SmallCardLayout.ReadMore, {
        customGrid: availabilityReadMoreGrid,
        children: /*#__PURE__*/_jsx(AirportAvailability, {
          isMultiStop: isMultiStop,
          productData: updatedProductData,
          testid: "availability-readmore"
        })
      }), /*#__PURE__*/_jsx("div", {
        className: availabilityWidgetWrapper,
        children: availabilityWidget
      })]
    });
  }
  return /*#__PURE__*/_jsxs(ProductLayout, {
    productData: updatedProductData,
    ref: rootElement,
    children: [shouldDisplayAvailability && /*#__PURE__*/_jsx(ProductLayout.ReadMore, {
      customGrid: availabilityReadMoreGrid,
      children: /*#__PURE__*/_jsx(AirportAvailability, {
        isMultiStop: isMultiStop,
        productData: updatedProductData,
        testid: "availability-readmore"
      })
    }), availabilityWidget]
  });
};
const mapStateToProps = (state, {
  form
}) => ({
  isSelected: getSelected(FAST_TRACK.name, form)(state)
});
export default connect(mapStateToProps)(FastTrack);
//# sourceMappingURL=FastTrack.js.map